import { baseApi } from "@/redux/api/baseApi";

export const creatorTatApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreatorTurnAroundTime: builder.query({
      query: ({ email }: { email: string }) => ({
        url: `/creator-tat/v2/${email}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetCreatorTurnAroundTimeQuery } = creatorTatApi;
